import type { Dispatch } from 'react';
import { useTranslation } from 'react-i18next';

import FormField from '@/components/atoms/FormField';
import TextArea from '@/components/atoms/TextArea';
import TextField from '@/components/atoms/TextField';
import styles from '@/routes/Internal/routes/Client/FishGroupsOverview/actions/operations/operateModals.module.scss';
import type {
    OperateWizardAction,
    WizardDestination,
} from '@/routes/Internal/routes/Client/FishGroupsOverview/actions/operations/operateWizardReducer';

interface Props {
    mergeTargetDestination: WizardDestination;
    dispatch: Dispatch<OperateWizardAction>;
}

/**
 * Count and Notes only make sense once the merge target is fully defined: cage picked AND, on
 * the empty branch, a second source picked. Rendering them earlier asks the operator to fill
 * numbers for a still-incomplete operation.
 */
export function TargetCountFields(props: Props) {
    const { mergeTargetDestination, dispatch } = props;
    const { t } = useTranslation('fishGroups');

    return (
        <>
            <FormField
                size="sm"
                htmlFor={`${mergeTargetDestination.tempId}-count`}
                label={t('actions.operate.destinations.fields.estimatedCount')}>
                <TextField
                    id={`${mergeTargetDestination.tempId}-count`}
                    type="number"
                    min={1}
                    value={mergeTargetDestination.estimatedFishCount}
                    onChange={(e) =>
                        dispatch({
                            type: 'setDestinationEstimatedCount',
                            tempId: mergeTargetDestination.tempId,
                            value: e.target.value,
                        })
                    }
                />
            </FormField>

            <FormField
                size="sm"
                htmlFor={`${mergeTargetDestination.tempId}-notes`}
                label={t('actions.operate.destinations.fields.notes')}
                className={styles['field--fullWidth']}>
                <TextArea
                    id={`${mergeTargetDestination.tempId}-notes`}
                    rows={2}
                    value={mergeTargetDestination.notes}
                    onChange={(e) =>
                        dispatch({
                            type: 'setDestinationNotes',
                            tempId: mergeTargetDestination.tempId,
                            value: e.target.value,
                        })
                    }
                />
            </FormField>
        </>
    );
}
